import * as i18n from 'i18next';
import type { InitOptions } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend, { type HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const getTranslationCacheVersion = () =>
  typeof __MAVUE_TRANSLATION_VERSION__ === 'string' ? __MAVUE_TRANSLATION_VERSION__ : 'local';

export const createI18nConfig = (): InitOptions<HttpBackendOptions> => ({
  fallbackLng: 'en',
  debug: false,
  interpolation: {
    escapeValue: false,
  },
  backend: {
    queryStringParams: {
      v: getTranslationCacheVersion(),
    },
  },
});

export const initI18Next = () => {
  return i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init(createI18nConfig());
};
